
import { createSlice } from '@reduxjs/toolkit';

const getInitialLanguage = () => {
  const savedLanguage = localStorage.getItem('language');
  return savedLanguage ? savedLanguage : 'en';
};

export const languageSlice = createSlice({
  name: 'language',
  initialState: {
    language: getInitialLanguage(),
    langForm : getInitialLanguage() , 
    supportedLanguages:['ar','en','fr']
  },
  reducers: {

      setLangForm(state, action) {
        state.langForm = action.payload;
      },
    setLanguage: (state, action) => {
      state.language = action.payload;
      localStorage.setItem('language', action.payload);
    },
  },
});
export const selectLangForm = (state) => state.language.langForm;
export const { setLanguage , setLangForm } = languageSlice.actions;
export default languageSlice.reducer;

export const supportedLanguagesSelector= state => state.language.supportedLanguages;
export const defaultLanguageSelector= state => state.language.language;